/**
 * @file wms-doc-totals.ts
 * @description Итоги складского документа: «позиций · количество»
 * (phase19.23 этап A).
 *
 * Количества приходят строками (Decimal без потерь), а в шапке документа и в
 * списке нужен один и тот же ответ «3 · 12 шт». Чистые функции вынесены из
 * компонентов, чтобы арифметика проверялась юнит-тестом, а не глазами.
 */

/** Минимум полей строки документа, нужный для итогов. */
export interface QuantityRow {
  quantity: string;
}

/**
 * Сумма количеств по строкам. Нечисловые значения игнорируем: документ с
 * битой строкой должен показать сумму остальных, а не `NaN`.
 */
export function sumQuantity(items: readonly QuantityRow[] | undefined | null): number {
  if (!items?.length) return 0;
  return items.reduce((acc, item) => {
    const value = Number(item.quantity);
    return Number.isFinite(value) ? acc + value : acc;
  }, 0);
}

/** Количество для показа: без хвоста `.00`, с разделителем разрядов. */
export function formatQuantity(value: number): string {
  return value.toLocaleString("ru-RU", { maximumFractionDigits: 3 });
}

/**
 * Подпись итогов документа: «3 · 12 шт». Пустой документ — «0 позиций»,
 * чтобы плитка не показывала бессмысленное «0 · 0 шт».
 */
export function formatDocTotals(items: readonly QuantityRow[] | undefined | null): string {
  const count = items?.length ?? 0;
  if (count === 0) return "0 позиций";
  return `${count} · ${formatQuantity(sumQuantity(items))} шт`;
}
